export const fmtBRL = (n: number) =>
  n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 2 });

export const fmtNum = (n: number) => n.toLocaleString("pt-BR");

export const fmtBytes = (b: number) => {
  if (!b) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  const i = Math.min(u.length - 1, Math.floor(Math.log(b) / Math.log(1024)));
  return `${(b / Math.pow(1024, i)).toFixed(1)} ${u[i]}`;
};

export const fmtDur = (ms: number) => {
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)}s`;
  const m = Math.floor(s / 60);
  return `${m}m ${Math.round(s - m * 60)}s`;
};
export const fmtDate = (s: string | null | undefined) => {
  if (!s) return "—";
  try {
    // Se for formato YYYY-MM-DD HH:mm:ss ou ISO, pegamos apenas a parte da data
    const isoDate = s.includes("T") ? s.split("T")[0] : s.split(" ")[0];
    const parts = isoDate.split("-");
    
    if (parts.length === 3) {
      const [y, m, d] = parts;
      return `${d}/${m}/${y}`;
    }
    
    const dt = new Date(s);
    if (isNaN(dt.getTime())) return s;
    return dt.toLocaleDateString("pt-BR");
  } catch { return s; }
};

export const maskCnpjCpf = (val: string) => {
  if (!val) return val;
  const digits = val.replace(/\D/g, "");
  if (digits.length === 14) {
    return `**.***.${digits.slice(5, 8)}/0001-${digits.slice(12)}`;
  }
  if (digits.length === 11) {
    return `***.***.${digits.slice(6, 9)}-${digits.slice(9)}`;
  }
  return "***.***.***-**";
};

export const maskName = (name: string) => {
  if (!name) return name;
  const parts = name.trim().split(" ");
  if (parts.length === 1) return name.charAt(0) + "******";
  const firstWord = parts[0];
  const lastWord = parts[parts.length - 1];
  return `${firstWord.charAt(0)}****** ${lastWord}`;
};
